<section class="section-title">

    <div class="section-title-image">
        <img class="device-image" src="assets/img/owner.png" />
    </div>

    <div class="section-title-text">
        <h1 i18n="@@owners_title">Gestori</h1>
    </div>
  
</section>

<section>

    <div  *ngIf="!isService()"  class="buttons-container">
        <a (click)="addOwner()" class="button">
            <ng-container i18n="@@owners_add_owner">Aggiungi gestore</ng-container> <span><fa-icon icon="user"></fa-icon></span>
        </a>
    </div>

    <app-owners-list (selected)="onOwnerSelected($event)"></app-owners-list>

</section>